(() => {
    const WebFont = require('webfontloader');
    WebFont.load({
        google: {
            families: ['Red+Hat+Display:400,700:latin-ext', 'Inter:300,400,500:latin-ext', 'Inter-Tight:400:latin-ext']
        }
    });
})();

